import React from 'react';

const DashTable = ({ company, data }) => {
  return (
    <>
      <h2 className='title'>Totales Recaudados</h2>
      <table className='rdt_Table'>
        <thead className='rdt_TableHeadRow'>
          <tr>
            <th className='rdt_TableCol'>Año</th>
            <th className='rdt_TableCol'>Total Recaudado</th>
            <th className='rdt_TableCol'>Cantidad de Transacciones</th>
          </tr>
        </thead>
        <tbody>
          {data.map((item, index) => (
            <tr
              key={index}
              className='rdt_TableRow'>
              <td>{item.year}</td>
              <td>
                {item.totalRecaudado.toLocaleString('es-CO', {
                  style: 'currency',
                  currency: 'COP',
                })}
              </td>
              <td>{item.transacciones}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </>
  );
};

export default DashTable;
